import CheckboxItem from "../Menu/CheckboxItem.vue";
import Divider from "../Menu/Divider.vue";
import Item from "../Menu/Item.vue";
import LinkItem from "../Menu/LinkItem.vue";
import RouteItem from "../Menu/RouteItem.vue";
import SectionHeader from "../Menu/SectionHeader.vue";
import Container from "./Container.vue";
import Root from "./Root.vue";
import Trigger from "./Trigger.vue";

export default {
  CheckboxItem,
  Container,
  Divider,
  Item,
  LinkItem,
  Root,
  RouteItem,
  SectionHeader,
  Trigger,
};
